// CONSTANTS are all caps.
const NS = 'QuantityInput';
const CLS = 'quantityInput';
const WG = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/quantityInput.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'


export class QuantityInput {
	constructor($el) {
		// $el is the widget node return by the loadQuantityInput function
		this.$el = $el;
	}

	init() {
		this.setQuantityInput();
	}

	setQuantityInput() {
		// Add Some logic here
		const $wg = $(this.$el);
		let $btns = $wg.find('.btn-up, .btn-down');
		let $input = $wg.find('input');
		let max = $input.attr('max');

		$input.on('keypress', function(e) {
			let code = e.keyCode || e.which;

			// prevent (. , + - e)
			if (code == 46 || code == 44 || code == 43 || code == 45 || code == 101) {
				e.preventDefault();
				return;
			}
		});

		$input.on('input', function() {
			let newValue = $input.val();

			// prevent values higher than the max
			if (max) {
				if (parseInt(newValue) > parseInt(max)) {
					$input.val(max);
					return;
				}
			}
		});

		$btns.on('click', function() {
			if ($(this).hasClass('btn-up')) {
				let next = parseInt($input.val()) + 1;

				if (max) {
					if (next > parseInt(max)) return;
				}

				$input.val(next);
			} else {
				if (parseInt($input.val()) > 1) {
					$input.val(parseInt($input.val()) - 1);
				}
			}
		});
	}

	// Add more functions like on above here
}



// WEBPACK FOOTER //
// C:/Users/GavinDow/source/repos/FrontEndWebsite/src/views/widgets/quantityInput/js/quantityInput.js